module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "resumeboxs flex"
  }, [_c('div', {
    staticClass: "head-image"
  }, [(_vm.item.headImage) ? _c('img', {
    attrs: {
      "src": _vm.item.headImage,
      "alt": ""
    }
  }) : _c('img', {
    attrs: {
      "src": "//oss.51ztx.com/resu.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex-grow"
  }, [_c('div', {
    staticClass: "tit-name flex"
  }, [_vm._v(_vm._s(_vm.item.name) + "\n      "), (_vm.item.type === 2) ? _c('div', {
    staticClass: "from-out"
  }, [_vm._v("赴外招聘")]) : _vm._e()]), _vm._v(" "), (_vm.type === 'default') ? [_c('div', {
    staticClass: "tit-post flex"
  }, [_c('div', {
    staticClass: "m-r-16"
  }, [_vm._v(_vm._s(_vm.item.recruitTitle))]), _vm._v(" "), (_vm.item.provideCarsubsidy * 1 === 1) ? _c('div', {
    staticClass: "tit-sub"
  }, [_vm._v("面试补贴")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "flex detail-ls"
  }, [(_vm.item.sexName) ? _c('div', [_vm._v(_vm._s(_vm.item.sexName))]) : _vm._e(), _vm._v(" "), (_vm.item.age) ? _c('div', [_vm._v(_vm._s(_vm.item.age) + "岁")]) : _vm._e(), _vm._v(" "), (_vm.item.educationName) ? _c('div', [_vm._v(_vm._s(_vm.item.educationName))]) : _vm._e(), _vm._v(" "), (_vm.item.homeProvincename) ? _c('div', [_vm._v(_vm._s(_vm.item.homeProvincename) + _vm._s(_vm.item.homeCityname))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "time"
  }, [(_vm.tabindex === 0) ? _c('span', [_vm._v(_vm._s(_vm.item.deliverTime))]) : _vm._e(), _vm._v(" "), (_vm.tabindex === 1) ? _c('span', [_vm._v(_vm._s(_vm.item.inviteFaceTime))]) : _vm._e(), _vm._v(" "), (_vm.tabindex === 2) ? _c('span', [_vm._v(_vm._s(_vm.item.inviteOnTime))]) : _vm._e(), _vm._v(" "), (_vm.tabindex === 3) ? _c('span', [_vm._v(_vm._s(_vm.item.finishTime))]) : _vm._e(), _vm._v(" "), (_vm.tabindex === 4) ? _c('span', [_vm._v(_vm._s(_vm.item.finishTime))]) : _vm._e()]), _vm._v(" "), ([0].includes(Number(_vm.tabindex))) ? _c('div', {
    staticClass: "resume-btn-groups"
  }, [_c('router-link', {
    staticClass: "resumebtn primary-border-btn",
    attrs: {
      "to": {
        path: '/index/resume/info',
        query: {
          workerDeliverId: _vm.item.id,
          recruitId: _vm.item.recruitId
        }
      }
    }
  }, [_vm._v("\n          简历详情\n        ")]), _vm._v(" "), (_vm.item.isColl === 0) ? _c('div', {
    staticClass: "resumebtn primary-border-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.downloadResume($event)
      }
    }
  }, [_vm._v("\n          下载简历\n        ")]) : _c('div', {
    staticClass: "resumebtn primary-border-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._v("\n          已下载\n        ")]), _vm._v(" "), ([1, 2, 11, 12, 6].includes(_vm.item.status)) ? _c('div', {
    staticClass: "resumebtn error-border-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.qppRejectInterview(_vm.item.id)
      }
    }
  }, [_vm._v("\n          不合适\n        ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.tabindex === 1) ? _c('div', {
    staticClass: "resume-btn-groups"
  }, [_c('router-link', {
    staticClass: "resumebtn primary-border-btn",
    attrs: {
      "to": {
        path: '/index/resume/info',
        query: {
          workerDeliverId: _vm.item.id,
          provideCarsubsidy: _vm.item.provideCarsubsidy,
          carsubsidy: _vm.item.carsubsidy,
          recruitId: _vm.item.recruitId
        }
      }
    }
  }, [_vm._v("\n          简历详情\n        ")]), _vm._v(" "), ([1, 2, 11, 12].includes(_vm.item.status)) ? _c('div', {
    staticClass: "resumebtn primary-border-btn",
    on: {
      "click": function($event) {
        _vm.appInterview(_vm.item.id)
      }
    }
  }, [_vm._v("\n          约面试\n        ")]) : _vm._e(), _vm._v(" "), ([1, 2, 11, 12, 4, 6].includes(_vm.item.status)) ? _c('div', {
    staticClass: "resumebtn primary-border-btn",
    on: {
      "click": function($event) {
        _vm.appInterviewSuccess(_vm.item.id)
      }
    }
  }, [_vm._v("\n          已上岗\n        ")]) : _vm._e(), _vm._v(" "), ([1, 2, 11, 12, 6].includes(_vm.item.status)) ? _c('div', {
    staticClass: "resumebtn error-border-btn",
    on: {
      "click": function($event) {
        _vm.qppRejectInterview(_vm.item.id)
      }
    }
  }, [_vm._v("\n          不合适\n        ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.tabindex === 2) ? _c('div', {
    staticClass: "resume-btn-groups"
  }, [_c('router-link', {
    staticClass: "resumebtn primary-border-btn",
    attrs: {
      "to": {
        path: '/index/resume/info',
        query: {
          workerDeliverId: _vm.item.id,
          recruitId: _vm.item.recruitId
        }
      }
    }
  }, [_vm._v("\n          查看详情\n        ")]), _vm._v(" "), ([4].includes(_vm.item.status)) ? _c('div', {
    staticClass: "resumebtn primary-border-btn",
    on: {
      "click": function($event) {
        _vm.interviewPass(_vm.index)
      }
    }
  }, [_vm._v("\n          面试通过\n        ")]) : _vm._e(), _vm._v(" "), ([1, 2, 11, 12, 4, 6].includes(_vm.item.status)) ? _c('div', {
    staticClass: "resumebtn primary-border-btn",
    on: {
      "click": function($event) {
        _vm.appInterviewSuccess(_vm.item.id)
      }
    }
  }, [_vm._v("\n          已上岗\n        ")]) : _vm._e(), _vm._v(" "), ([4].includes(_vm.item.status)) ? _c('div', {
    staticClass: "resumebtn error-border-btn",
    on: {
      "click": function($event) {
        _vm.interviewFailView(_vm.item.id)
      }
    }
  }, [_vm._v("\n          不通过\n        ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.tabindex === 3) ? _c('div', {
    staticClass: "resume-btn-groups"
  }) : _vm._e(), _vm._v(" "), (_vm.tabindex === 5) ? _c('div', {
    staticClass: "resume-btn-groups"
  }, [_c('router-link', {
    staticClass: "resumebtn primary-border-btn",
    attrs: {
      "to": {
        path: '/index/resume/info',
        query: {
          workerId: _vm.item.id,
          recruitId: _vm.item.recruitId,
          isCol: true
        }
      }
    }
  }, [_vm._v("\n          查看详情\n        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.tabindex === 6) ? _c('div', {
    staticClass: "resume-btn-groups"
  }, [_c('router-link', {
    staticClass: "resumebtn primary-border-btn",
    attrs: {
      "to": {
        path: '/index/resume/info',
        query: {
          workerId: _vm.item.workerId,
          recruitId: _vm.item.recruitId,
          isCol: true
        }
      }
    }
  }, [_vm._v("\n          查看详情\n        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.tabindex === 4) ? _c('div', {
    staticClass: "resume-btn-groups"
  }, [_c('router-link', {
    staticClass: "resumebtn primary-border-btn",
    attrs: {
      "to": {
        path: '/index/resume/info',
        query: {
          workerDeliverId: _vm.item.id,
          recruitId: _vm.item.recruitId
        }
      }
    }
  }, [_vm._v("\n          查看详情\n        ")]), _vm._v(" "), ([1, 2, 11, 12, 4, 6].includes(_vm.item.status)) ? _c('div', {
    staticClass: "resumebtn primary-border-btn",
    on: {
      "click": function($event) {
        _vm.appInterviewSuccess(_vm.item.id)
      }
    }
  }, [_vm._v("\n          已上岗\n        ")]) : _vm._e(), _vm._v(" "), ([6].includes(_vm.item.status)) ? _c('div', {
    staticClass: "resumebtn error-border-btn",
    on: {
      "click": function($event) {
        _vm.failPost(_vm.item.id)
      }
    }
  }, [_vm._v("\n          未上岗\n        ")]) : _vm._e()], 1) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.type === 'talent') ? [_c('div', {
    staticClass: "tit-post flex flex-between"
  }, [(_vm.item.expectPositionname) ? _c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "light"
  }, [_vm._v("求职意向：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.item.expectPositionname))]), _vm._v(" "), (_vm.item.expectCityname) ? [_c('div', {
    staticClass: "v-line"
  }), _vm._v(" "), _c('div', {}, [_vm._v(_vm._s(_vm.item.expectCityname))])] : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.item.expectMinsalary) ? _c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "light"
  }, [_vm._v("期待薪资：")]), _vm._v("\n          ￥" + _vm._s(_vm.item.expectMinsalary) + "~" + _vm._s(_vm.item.expectMaxsalary) + "\n        ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "flex detail-ls"
  }, [(_vm.item.sexName) ? _c('div', [_vm._v(_vm._s(_vm.item.sex))]) : _vm._e(), _vm._v(" "), (_vm.item.age) ? _c('div', [_vm._v(_vm._s(_vm.item.age) + "岁")]) : _vm._e(), _vm._v(" "), (_vm.item.education) ? _c('div', [_vm._v(_vm._s(_vm.item.education))]) : _vm._e(), _vm._v(" "), (_vm.item.homeCityname) ? _c('div', [_vm._v(_vm._s(_vm.item.homeCityname))]) : _vm._e()])] : _vm._e()], 2), _vm._v(" "), (_vm.type === 'talent') ? _c('div', {
    staticClass: "btn-ls"
  }, [_c('router-link', {
    staticClass: "primary-btn",
    attrs: {
      "to": {
        path: '/index/searchlistInfo',
        query: {
          workerId: _vm.item.id,
          isCol: true
        }
      },
      "target": "_blank"
    }
  }, [_vm._v("\n      查看简历\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-center pointer",
    staticStyle: {
      "color": "#333333",
      "font-size": "14px"
    },
    on: {
      "click": _vm.downloadResume
    }
  }, [(_vm.item.isColl === 0) ? [_c('img', {
    staticStyle: {
      "width": "16px",
      "height": "16px",
      "margin-right": "6px"
    },
    attrs: {
      "src": require("../assets/images/resume/download_icon.png"),
      "alt": ""
    }
  }), _vm._v("\n        下载简历\n      ")] : [_vm._v("\n        已添加\n      ")]], 2)], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c4c7af0e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/resumeItem.vue
// module id = 909
// module chunks = 1